import(/* webpackChunkName: "contentTeaserBlock" */ 'Feature/ContentElements/code/ContentTeaserBlock/Styles/contentTeaserBlock.scss');
import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');

window.addEventListener('load', () => {
    import(/* webpackChunkName: "contentTeaserBlock" */ 'Foundation/Common/code/Frontend/components/molecules/contentTeaserBlock/contentTeaserBlock.cmp');

    // lazysizes caluclates the wrong data-size for the first contentpage teaser block row
    // depends on the other image elements in this component.
    // Could not find an event yet to trigger the calculation of the data-size after the
    // the calculation was fired.
    window.dispatchEvent(new Event('resize'));
});
